var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-select',{attrs:{"value":_vm.value,"clearable":true},on:{"input":_vm.input}},_vm._l((_vm.destinations),function(item,key){return _c('i-option',{key:key,attrs:{"value":item,"label":_vm.$t(("pbx.stat.common.field." + item))}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }